<template>
  <div class="dashboard">
    <v-dialog v-model="dialogVisible" persistent>
      <a href="#" style="text-decoration: none;">
        <v-card color="primary" dark @click="logout">
          <v-card-title class="headline">
            Contratto non ancora verificato
          </v-card-title>
          <v-card-text>
            Gentile cliente, Stiamo verificando il contratto caricato durante la registrazione. Riceverà una mail non appena il contratto verrà verificato<br>
            <b>Grazie mille e a presto, da parte di tutto il team Ambrosi Partner</b>
            <br>
            <b>Clicca qui per effettuare il log out </b>
          </v-card-text>
        </v-card>
      </a>
    </v-dialog>

    <section class="dashboard-section">
      <h2 class="dashboard-section__title">Pratiche</h2>
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <button type="button" class="dash-tile dash-tile--primary" @click="go('/modules/new')">
            <v-icon dark class="dash-tile__icon">fas fa-plus-circle</v-icon>
            <span class="dash-tile__label">Nuova pratica</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button type="button" class="dash-tile dash-tile--primary-soft" @click="go('/modules/drafts')">
            <v-icon dark class="dash-tile__icon">fas fa-file-alt</v-icon>
            <span class="dash-tile__label">Pratiche in bozza</span>
            <span class="dash-tile__metric">{{ uploadedModules }}</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button type="button" class="dash-tile dash-tile--primary-soft" @click="go('/modules/sent')">
            <v-icon dark class="dash-tile__icon">fas fa-paper-plane</v-icon>
            <span class="dash-tile__label">Pratiche inviate</span>
            <span class="dash-tile__metric">{{ sentModules }}</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button type="button" class="dash-tile dash-tile--primary-soft" @click="go('/modules/elaborate')">
            <v-icon dark class="dash-tile__icon">fas fa-check-double</v-icon>
            <span class="dash-tile__label">Pratiche elaborate</span>
            <span class="dash-tile__metric">{{ completedModules }}</span>
          </button>
        </v-col>
      </v-row>
    </section>

    <section class="dashboard-section">
      <h2 class="dashboard-section__title">Documenti e guide</h2>
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <button type="button" class="dash-tile dash-tile--secondary" @click="go('/utility-docs')">
            <v-icon dark class="dash-tile__icon">fas fa-folder-open</v-icon>
            <span class="dash-tile__label">Documenti utili</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button
            type="button"
            class="dash-tile dash-tile--secondary"
            @click="openInNewTab('/assets/EasyENEA-ottimizzazione caricamento pratica.pdf')"
          >
            <v-icon dark class="dash-tile__icon">fas fa-tachometer-alt</v-icon>
            <span class="dash-tile__label">Guida all'ottimizzazione caricamento pratica</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button
            type="button"
            class="dash-tile dash-tile--secondary"
            @click="openInNewTab('/assets/TutorialExportENEA.pdf')"
          >
            <v-icon dark class="dash-tile__icon">fas fa-file-export</v-icon>
            <span class="dash-tile__label">Tutorial Export ENEA Fattura Infissi</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <button
            type="button"
            class="dash-tile dash-tile--secondary"
            @click="openInNewTab('/assets/File marketing clienti.zip')"
          >
            <v-icon dark class="dash-tile__icon">fas fa-bullhorn</v-icon>
            <span class="dash-tile__label">File marketing per i clienti</span>
          </button>
        </v-col>
      </v-row>
    </section>

    <section class="dashboard-section">
      <h2 class="dashboard-section__title">Crediti</h2>
      <v-row dense>
        <v-col cols="12" sm="6">
          <button type="button" class="dash-tile dash-tile--lime" @click="go('/wallet/' + user.id)">
            <v-icon dark class="dash-tile__icon">fas fa-wallet</v-icon>
            <span class="dash-tile__label">Crediti residui</span>
            <span class="dash-tile__metric">{{ credits }}</span>
          </button>
        </v-col>
        <v-col cols="12" sm="6">
          <button type="button" class="dash-tile dash-tile--lime" @click="go('/packages')">
            <v-icon dark class="dash-tile__icon">fas fa-shopping-cart</v-icon>
            <span class="dash-tile__label">Acquista il servizio</span>
          </button>
        </v-col>
      </v-row>
    </section>

    <section class="dashboard-section dashboard-section--promo">
      <button
        type="button"
        class="dash-promo"
        @click="openInNewTab('/assets/BROCHUERE ACQ. DATI PIATTAFORMA EasyENEA.pdf')"
      >
        <div class="dash-promo__content">
          <span class="dash-promo__eyebrow">Servizio Ambrosi Partner</span>
          <span class="dash-promo__title">
            Non hai tempo per le pratiche ENEA? Scopri il “servizio acquisizione dati beneficiario”
          </span>
          <span class="dash-promo__cta">
            Apri la brochure
            <v-icon dark small class="ml-2">fas fa-external-link-alt</v-icon>
          </span>
        </div>
      </button>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCountModules } from "@/api/module.api.js";
import { getCredits } from "@/api/accounts.api.js";

export default {
  name: "Dashboard",
  data() {
    return {
      uploadedModules: 0,
      sentModules: 0,
      completedModules: 0,
      credits: 0,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "authentication/user",
    }),
  },
  mounted() {
    getCredits().then((res) => {
      this.credits = res.data;
    });
    getCountModules()
      .then((res) => {
        this.uploadedModules = res.data.drafts;
        this.sentModules = res.data.sent;
        this.completedModules = res.data.completed;
      })
      .catch((err) => {
        console.log(err);
      });

    if (!this.user.isContractVerified) {
      this.dialogVisible = true;
    }
  },
  methods: {
    go(path) {
      this.$router.push(path).catch(() => {});
    },
    openInNewTab(href) {
      Object.assign(document.createElement("a"), {
        target: "_blank",
        href: href,
      }).click();
    },
    logout() {
      this.$store.dispatch("authentication/logout", true);
    },
  },
};
</script>

<style scoped>
.dashboard {
  --dash-primary: #0d6f4f;
  --dash-primary-soft: #2b8a37;
  --dash-secondary: #1077ad;
  --dash-lime: #7a9e2f;
  --dash-orange: #ee9223;
  --dash-ink: #16352b;
  padding: 4px 2px 24px;
}

.dashboard-section {
  margin-bottom: 28px;
}

.dashboard-section__title {
  margin: 0 0 12px;
  color: var(--dash-ink);
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.dash-tile {
  width: 100%;
  min-height: 148px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 18px;
  border: 0;
  border-radius: 14px;
  color: #fff;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(13, 55, 40, 0.12);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.dash-tile:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(13, 55, 40, 0.18);
  filter: brightness(1.04);
}

.dash-tile:focus {
  outline: 2px solid rgba(255, 255, 255, 0.7);
  outline-offset: 2px;
}

.dash-tile--primary {
  background: linear-gradient(145deg, #0d6f4f 0%, #095c42 100%);
}

.dash-tile--primary-soft {
  background: linear-gradient(145deg, #2b8a37 0%, #21702c 100%);
}

.dash-tile--secondary {
  background: linear-gradient(145deg, #1077ad 0%, #0c5f8a 100%);
}

.dash-tile--lime {
  background: linear-gradient(145deg, #8fb53c 0%, #6f9228 100%);
}

.dash-tile__icon {
  opacity: 0.92;
}

.dash-tile__label {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.25;
  color: #fff;
}

.dash-tile__metric {
  display: block;
  margin-top: auto;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
  color: #fff;
}

.dash-promo {
  width: 100%;
  min-height: 150px;
  padding: 28px 28px;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  text-align: left;
  color: #fff;
  background:
    radial-gradient(circle at top right, rgba(255, 255, 255, 0.18), transparent 42%),
    linear-gradient(120deg, #ee9223 0%, #d97812 55%, #c45f0c 100%);
  box-shadow: 0 14px 30px rgba(196, 95, 12, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.dash-promo:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 34px rgba(196, 95, 12, 0.28);
  filter: brightness(1.03);
}

.dash-promo__content {
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dash-promo__eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.92;
}

.dash-promo__title {
  font-size: clamp(1.2rem, 2.2vw, 1.65rem);
  font-weight: 800;
  line-height: 1.25;
}

.dash-promo__cta {
  display: inline-flex;
  align-items: center;
  margin-top: 6px;
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 600px) {
  .dash-tile {
    min-height: 124px;
  }

  .dash-promo {
    padding: 22px 18px;
  }
}
</style>
